import { mangaList } from '@/mocks/manga';

export default function HotPicks() {
  const picks = mangaList.filter((m) => m.isHot).slice(0, 3);

  return (
    <section id="hot" className="scroll-mt-20 bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex items-end justify-between">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-semibold text-primary-700">
              <i className="ri-fire-fill" /> 编辑精选
            </span>
            <h2 className="font-display mt-3 text-2xl font-bold text-foreground-900 md:text-4xl">
              热门推荐
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              近期人气与口碑双高的作品，不知道看什么就从这里开始。
            </p>
          </div>
          <a
            href="#latest"
            className="hidden items-center gap-1 whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium text-primary-700 transition-colors hover:bg-primary-100 sm:flex"
          >
            查看全部 <i className="ri-arrow-right-line" />
          </a>
        </div>

        <div className="mt-8 grid gap-6 md:grid-cols-3">
          {picks.map((manga, index) => (
            <article
              key={manga.id}
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-transform duration-300 hover:-translate-y-1 md:flex-row"
            >
              <div className="relative aspect-[16/11] w-full overflow-hidden md:aspect-auto md:w-2/5">
                <img
                  src={manga.cover}
                  alt={`${manga.title} 热门推荐封面`}
                  title={`${manga.title} 热门推荐`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-2 top-2 rounded-md bg-primary-500 px-2 py-0.5 text-xs font-bold text-background-50">
                  NO.{index + 1}
                </span>
              </div>
              <div className="flex flex-1 flex-col gap-2.5 p-4">
                <h3 className="font-display text-lg font-bold text-foreground-900">{manga.title}</h3>
                <div className="flex flex-wrap gap-1.5">
                  {manga.tags.map((tag) => (
                    <span
                      key={tag}
                      className="rounded-full bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
                <p className="line-clamp-2 text-xs leading-relaxed text-foreground-600">
                  {manga.description}
                </p>
                <div className="mt-auto space-y-1.5 text-xs text-foreground-500">
                  <p className="flex items-center gap-1.5">
                    <i className="ri-star-fill text-accent-500" />
                    {manga.rating.toFixed(1)} 分 · 已更 {manga.chapters} 话 · {manga.views} 人气
                  </p>
                  <p className="truncate text-foreground-600">
                    最新：{manga.latest}
                  </p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}